import smart_vehicle from "../../assets/smart_vehicle.jpeg";
import oee from "../../assets/oee_.png";
const data = [
  {
    id: 1,
    title: "IOT Smart Vechicle Management",
    desc: "Smart Vehicle Management is a prototype project that replicates an industrial IIoT (Industrial Internet of Things) solution, similar to those used across various IIoT domains. It enables real-time monitoring and management of vehicles by collecting sensor data, analyzing performance, and predicting maintenance needs. Built with AWS, Kafka, TDengine, and Spring Boot, the system ensures scalable data ingestion, processing, and analytics, providing actionable insights to enhance operational efficiency. This architecture can be adapted for other industrial IIoT applications, such as manufacturing, logistics, and energy management.",
    src: smart_vehicle,
    link: "https://github.com/sharooque7/ZaberiBackend",
  },
  {
    id: 2,
    title: "Overall Equipment Efficiency",
    desc: "The Batch Processing for OEE (Overall Equipment Effectiveness) Calculation automates efficiency measurement in industrial operations. Upon file uploads to Amazon S3, an AWS Lambda (Java) function is triggered via EventBridge, processing key machine parameters like availability, performance, and quality. The computed OEE metrics are then stored in Amazon DynamoDB for real-time monitoring and historical analysis, enabling data-driven decision-making to optimize equipment performance.",
    src: oee,
    link: "https://github.com/sharooque7/ZaberiBackend",
  },
  // {
  //   id: 1,
  //   title: "ZaberiEcommerce",
  //   desc: "An ecommerce application .This is implemented using MERN stack.I have used Bootstrap for styling the frontend and also implemented paypal integration for payment .Used Redux for state management ",
  //   src: Zaberi,
  //   library: [
  //     "ReactJS",
  //     "NodeJs",
  //     "Redux",
  //     "Bootstrap",
  //     "CSS",
  //     "NoSQL",
  //     "MongoDB",
  //   ],
  //   liveApp: "https://zaberi.netlify.app/",
  //   Frontend: "https://github.com/sharooque7/ZaberiFront",
  //   Backend: "https://github.com/sharooque7/ZaberiBackend",
  // },
  // {
  //   id: 2,
  //   title: "Trave App",
  //   desc: "A small CRUD application where the travel enthusiast can post and edit the places that they admire.I have used NEXTJS for this implementation .This app will help others to plan their trip",
  //   src: next,
  //   library: [
  //     "ReactJS",
  //     "NodeJs",
  //     "NEXTJS",
  //     "materialUI",
  //     "CSS",
  //     "NoSQL",
  //     "MongoDB",
  //   ],
  //   liveApp: "https://travel-app-gold.vercel.app/",
  //   Frontend: "https://github.com/sharooque7/TravelApp.git",
  //   Backend: "https://github.com/sharooque7/TravelApp.git",
  // },
  // {
  //   id: 3,
  //   title: "Whatsapp Clone",
  //   desc: "A small clone of whatsapp . Here we can create a room and start chatting with people in the room . I have used ReactJS for frontEnd with ContextApi for state management with google authentication and storing data in firebase  ",
  //   src: whatsApp,
  //   library: [
  //     "ReactJS",
  //     "ContextApi",
  //     "MaterialUI",
  //     "Firebase",
  //     "CSS",
  //     "NoSQL",
  //   ],
  //   liveApp: "https://whatsapp-clone-a8525.web.app/",
  //   Frontend: "https://github.com/sharooque7/whatsapp-clone",
  //   Backend: "",
  // },
  // {
  //   id: 4,
  //   title: "Netflix Clone",
  //   desc: "A  clone of Netflix the popular streaming website . I have used TMDB Api's  to get the realtime data from internet .Here i have build only the frontend part for now with ReactJS and CSS and deployed this to firebase the backend functionality will be added later .",
  //   src: netflix,
  //   library: ["ReactJS", "Firebase", "CSS"],
  //   liveApp: "https://nelfiix-clone.netlify.app/",
  //   Frontend: "https://github.com/sharooque7/Netflix-clone.git",
  //   Backend: "",
  // },
  // {
  //   id: 5,
  //   title: "ChatApp",
  //   desc: "A Chat Application build using socket.io  . At a time two user has to be online to start conversation and  send messages . I have used redux for state management ",
  //   src: chat,
  //   library: ["ReactJS", "MongoDB", "Socket.io", "Nodejs", "Redux"],
  //   liveApp: "https://chatappsocial.netlify.app/",
  //   Frontend: "https://github.com/sharooque7/chatApp",
  //   Backend: "https://github.com/sharooque7/chatBackend",
  // },
  // {
  //   id: 6,
  //   title: "SocialLite",
  //   desc: "A Social media lite where user can share their post and chat with online users .This is a full stack MERN application also uses contextApi for state management The messaging part is build using socket.io. ",
  //   src: socialLite,
  //   library: [
  //     "ReactJS",
  //     "MongoDB",
  //     "CSS-flex",
  //     "Socket.io",
  //     "ContextApi",
  //     "Nodejs",
  //   ],
  //   liveApp: "https://sociallite.netlify.app/",
  //   Frontend: "https://github.com/sharooque7/socialLite",
  //   Backend: "https://github.com/sharooque7/socialLiteBackend",
  // },
];

export default data;
